import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export const MAINTENANCE_MODE_QUERY_KEY = ['system_settings', 'maintenanceMode'] as const

function parseBooleanish(value: unknown): boolean {
  if (value === true) return true
  if (value === false) return false
  if (typeof value === 'number') return value !== 0
  if (typeof value === 'string') return ['true', '1', 'yes'].includes(value.trim().toLowerCase())
  return false
}

async function fetchMaintenanceMode(): Promise<boolean> {
  const { data, error } = await supabase
    .from('system_settings')
    .select('value')
    .eq('key', 'maintenanceMode')
    .maybeSingle()

  if (error) throw error
  if (data?.value === null || data?.value === undefined) return false
  return parseBooleanish(data.value as unknown)
}

/** When true, non-staff users see the maintenance screen (enforced in `MaintenanceShell`). */
export function useMaintenanceMode() {
  return useQuery({
    queryKey: MAINTENANCE_MODE_QUERY_KEY,
    queryFn: fetchMaintenanceMode,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
  })
}
